'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrugDescription$drugBagdeData$() {
}
export { $c_Lapp_data_DrugDescription$drugBagdeData$ as $c_Lapp_data_DrugDescription$drugBagdeData$ };
$c_Lapp_data_DrugDescription$drugBagdeData$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrugDescription$drugBagdeData$.prototype.constructor = $c_Lapp_data_DrugDescription$drugBagdeData$;
/** @constructor */
function $h_Lapp_data_DrugDescription$drugBagdeData$() {
}
export { $h_Lapp_data_DrugDescription$drugBagdeData$ as $h_Lapp_data_DrugDescription$drugBagdeData$ };
$h_Lapp_data_DrugDescription$drugBagdeData$.prototype = $c_Lapp_data_DrugDescription$drugBagdeData$.prototype;
$c_Lapp_data_DrugDescription$drugBagdeData$.prototype.formulation__O__T = (function(a) {
  return a.Lapp_data_DrugDescription__f_formulation;
});
$c_Lapp_data_DrugDescription$drugBagdeData$.prototype.strength__O__T = (function(a) {
  return a.Lapp_data_DrugDescription__f_strength;
});
$c_Lapp_data_DrugDescription$drugBagdeData$.prototype.quantity__O__T = (function(a) {
  return a.Lapp_data_DrugDescription__f_quantity;
});
var $d_Lapp_data_DrugDescription$drugBagdeData$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrugDescription$drugBagdeData$, "app.data.DrugDescription$drugBagdeData$", ({
  Lapp_data_DrugDescription$drugBagdeData$: 1,
  Lapp_data_DrugBadgeData: 1
}));
export { $d_Lapp_data_DrugDescription$drugBagdeData$ as $d_Lapp_data_DrugDescription$drugBagdeData$ };
var $n_Lapp_data_DrugDescription$drugBagdeData$;
function $m_Lapp_data_DrugDescription$drugBagdeData$() {
  if ((!$n_Lapp_data_DrugDescription$drugBagdeData$)) {
    $n_Lapp_data_DrugDescription$drugBagdeData$ = new $c_Lapp_data_DrugDescription$drugBagdeData$();
  }
  return $n_Lapp_data_DrugDescription$drugBagdeData$;
}
export { $m_Lapp_data_DrugDescription$drugBagdeData$ as $m_Lapp_data_DrugDescription$drugBagdeData$ };
//# sourceMappingURL=app.data.-Drug-Description$drug-Bagde-Data$.js.map
